// This file is auto-generated. Do not edit!

export default [
  {
    bpt: "0x007bb7a4bfc214DF06474E39142288E99540f2b3",
    id: "0x007bb7a4bfc214df06474e39142288e99540f2b3000200000000000000000191",
    name: "20WETH-80IMO",
    type: "Weighted",
    gauge: "0x916D186B75aAe4729FcD22260da15486dCca2E3d",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x5A7a2bf9fFae199f088B25837DcD7E115CF8E1bb",
        symbol: "IMO",
      },
    ],
  },
  {
    bpt: "0x057cCEDf34e92B156822c473D505c3Bc17811138",
    id: "0x057ccedf34e92b156822c473d505c3bc17811138000200000000000000000204",
    name: "ECLP-WETH-cbBTC-dyn",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
        symbol: "cbBTC",
      },
    ],
  },
  {
    bpt: "0x0C659734f1eEF9C63B7Ebdf78a164CDd745586Db",
    id: "0x0c659734f1eef9c63b7ebdf78a164cdd745586db000000000000000000000046",
    name: "USDC/USDbC/axlUSDC",
    type: "ComposableStable",
    gauge: "0x29B0C494eD7d098F4930428F115DcAf42a92392b",
    tokens: [
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
      {
        address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
        symbol: "USDbC",
      },
      {
        address: "0xEB466342C4d449BC9f53A865D5Cb90586f405215",
        symbol: "axlUSDC",
      },
    ],
  },
  {
    bpt: "0x1681606d347678d94b77edf887C75bE28fE254Bd",
    id: "0x1681606d347678d94b77edf887c75be28fe254bd0002000000000000000001cf",
    name: "ECLP-sUSDe-GYD",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x211Cc4DD073734dA055fbF44a2b4667d5E5fE5d2",
        symbol: "sUSDe",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x17e7d59bB209a3215Ccc25FFfEf7161498B7C10d",
    id: "0x17e7d59bb209a3215ccc25fffef7161498b7c10d000200000000000000000020",
    name: "1WETH-99GOLD",
    type: "Weighted",
    gauge: "0x157a6dFD77F527efef0b36b5B2156B1aB710E32F",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0xbeFD5C25A59ef2C1316c5A4944931171F30Cd3E4",
        symbol: "GOLD",
      },
    ],
  },
  {
    bpt: "0x2A5757b60987FF10385De1D4D923792f6fdCfFf1",
    id: "0x2a5757b60987ff10385de1d4d923792f6fdcfff100010000000000000000019e",
    name: "25cbETH-25SNUT-25NUT-25cbBTC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2Ae3F1Ec7F1F5012CFEab0185bfc7aa3cf0DEc22",
        symbol: "cbETH",
      },
      {
        address: "0xAC130701aa31c284c36609E2489f150F419AD7AD",
        symbol: "SNUT",
      },
      {
        address: "0xb8DE15Fb529d98C93C749De63c749D48D25A30DF",
        symbol: "NUT",
      },
      {
        address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
        symbol: "cbBTC",
      },
    ],
  },
  {
    bpt: "0x2C0Ea123a2C7E2175f8204a8Ff2a37187eED24Ff",
    id: "0x2c0ea123a2c7e2175f8204a8ff2a37187eed24ff0002000000000000000001fb",
    name: "ECLP-WETH-USDC-dyn",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x2da6e67C45aF2aaA539294D9FA27ea50CE4e2C5f",
    id: "0x2da6e67c45af2aaa539294d9fa27ea50ce4e2c5f0002000000000000000001a3",
    name: "50OLAS-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x54330d28ca3357F294334BDC454a032e7f353416",
        symbol: "OLAS",
      },
    ],
  },
  {
    bpt: "0x2Db50a0e0310723EF0C2a165CB9A9f80D772ba2F",
    id: "0x2db50a0e0310723ef0c2a165cb9a9f80d772ba2f00020000000000000000000d",
    name: "BPT-50STABAL3-50WETH",
    type: "Weighted",
    gauge: "0x7733650c7aaF2074FD1fCf98f70cbC09138E1Ea5",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb",
        symbol: "DAI",
      },
      {
        address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
        symbol: "USDbC",
      },
    ],
  },
  {
    bpt: "0x327fc10dD65c117A9CFC449F2A86613Eb1265e91",
    id: "0x327fc10dd65c117a9cfc449f2a86613eb1265e910002000000000000000001dd",
    name: "ECLP-GYFI-GYD",
    type: "GyroE",
    gauge: "0xcC378C3A65107414D2980D4D4Bd73F8F0AfeF00E",
    tokens: [
      {
        address: "0xc63529297dE076eB15fcbE873AE9136E446cFbB9",
        symbol: "GYFI",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x41790F2985Dc2e0Efb7e4A73dC1C118f5d8aE7A1",
    id: "0x41790f2985dc2e0efb7e4a73dc1c118f5d8ae7a1000200000000000000000200",
    name: "ECLP-GYFI-WETH",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0xc63529297dE076eB15fcbE873AE9136E446cFbB9",
        symbol: "GYFI",
      },
    ],
  },
  {
    bpt: "0x433f09ca08623E48BAc7128B7105De678E37D988",
    id: "0x433f09ca08623e48bac7128b7105de678e37d988000100000000000000000047",
    name: "50GOLD/25WETH/25USDC",
    type: "Weighted",
    gauge: "0xdAe8AC766eB1c4Bb76Bc814FdE22AC46F467C51b",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
      {
        address: "0xbeFD5C25A59ef2C1316c5A4944931171F30Cd3E4",
        symbol: "GOLD",
      },
    ],
  },
  {
    bpt: "0x44d46A43ceb5A1e04Ef12B5731de5F9917f0eC8A",
    id: "0x44d46a43ceb5a1e04ef12b5731de5f9917f0ec8a000200000000000000000208",
    name: "20WETH/80VLR",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x4e107a0000DB66f0E9Fd2039288Bf811dD1f9c74",
        symbol: "VLR",
      },
    ],
  },
  {
    bpt: "0x4c42B5057A8663E2b1ac21685D1502c937a03817",
    id: "0x4c42b5057a8663e2b1ac21685d1502c937a0381700020000000000000000019c",
    name: "ECLP-WETH-USDC",
    type: "GyroE",
    gauge: "0xEdf537FFbc7C5ED4042AEdE5c0d2E14a41FdC121",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x5332584890D6E415a6dc910254d6430b8aaB7E69",
    id: "0x5332584890d6e415a6dc910254d6430b8aab7e69000200000000000000000103",
    name: "50OLAS-50USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x54330d28ca3357F294334BDC454a032e7f353416",
        symbol: "OLAS",
      },
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x6FbFcf88DB1aADA31F34215b2a1Df7fafb4883e9",
    id: "0x6fbfcf88db1aada31f34215b2a1df7fafb4883e900000000000000000000000c",
    name: "BPT-stabal3",
    type: "ComposableStable",
    gauge: "0xC97fa65107AE7b94FB749cF05abb01005c14351E",
    tokens: [
      {
        address: "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb",
        symbol: "DAI",
      },
      {
        address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
        symbol: "USDbC",
      },
    ],
  },
  {
    bpt: "0x79FE0750bE76913E83a0f0EB60ba1Ab7FA6FdA5D",
    id: "0x79fe0750be76913e83a0f0eb60ba1ab7fa6fda5d00020000000000000000019f",
    name: "ECLP-GYD-aUSDC",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x4EA71A20e655794051D1eE8b6e4A3269B13ccaCc",
        symbol: "stataBasUSDC",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x8670583BF7106c0Cf850552C027fFa2C21be0607",
    id: "0x8670583bf7106c0cf850552c027ffa2c21be060700020000000000000000020b",
    name: "ECLP-WETH-USDC-dyn",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x8F360BAf899845441Eccdc46525E26BB8860752A",
    id: "0x8f360baf899845441eccdc46525e26bb8860752a0002000000000000000001cd",
    name: "ECLP-USDbC-USDC",
    type: "GyroE",
    gauge: "0xb45841A402a5A26531889D573A380A9f920ddA6D",
    tokens: [
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
      {
        address: "0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA",
        symbol: "USDbC",
      },
    ],
  },
  {
    bpt: "0x97a3ecE859d9C1C41E225fbD6F10359dae7a73c9",
    id: "0x97a3ece859d9c1c41e225fbd6f10359dae7a73c9000200000000000000000202",
    name: "ECLP-WETH-USDC-dyn",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x990A0f03C3Ee397cAfDa61caD277DE18280751FD",
    id: "0x990a0f03c3ee397cafda61cad277de18280751fd0002000000000000000000b6",
    name: "50WETH-50TAG",
    type: "Weighted",
    gauge: "0x8d16A8C9173c1e0044d07F976a15F90aBd9A1090",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x7905EA12CC81a215A5F1D0F46DF73a53E19E9264",
        symbol: "TAG",
      },
    ],
  },
  {
    bpt: "0xa04259De0129ac4C4a0ce22BE2ec729482034ba0",
    id: "0xa04259de0129ac4c4a0ce22be2ec729482034ba000020000000000000000016d",
    name: "50AURA-50BAL",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
        symbol: "AURA",
      },
      {
        address: "0x4158734D47Fc9692176B5085E0F52ee0Da5d47F1",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0xa476E9f11b3b32c0DEbdD6b01d54b79C8eF14411",
    id: "0xa476e9f11b3b32c0debdd6b01d54b79c8ef144110002000000000000000001e5",
    name: "ECLP-cbBTC-USDC-dyn",
    type: "GyroE",
    gauge: "0x7A1C3576Bad49Ea1f3B1ba7E82A600903c88b505",
    tokens: [
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
      {
        address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
        symbol: "cbBTC",
      },
    ],
  },
  {
    bpt: "0xC3889F9764d68BDF2e16f237206746344172A147",
    id: "0xc3889f9764d68bdf2e16f237206746344172a14700020000000000000000018e",
    name: "20ZBU-80USDC OLP",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2C8C89C442436CC6C0a77943E09c8Daf49Da3161",
        symbol: "ZBU",
      },
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xCB470dA0902e6c548F0e8161042f624599286E9B",
    id: "0xcb470da0902e6c548f0e8161042f624599286e9b000200000000000000000105",
    name: "80AURA-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
        symbol: "AURA",
      },
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xCDc9574b4a07f47dA0150Fe67BAA2ff93766CaFD",
    id: "0xcdc9574b4a07f47da0150fe67baa2ff93766cafd0002000000000000000001e0",
    name: "ECLP-GYFI-GYD",
    type: "GyroE",
    gauge: "0xAbb4101c560b7F7A84cE903F11761Fe2144D3829",
    tokens: [
      {
        address: "0xc63529297dE076eB15fcbE873AE9136E446cFbB9",
        symbol: "GYFI",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0xd0fAB38d17f4Ae1dB607E91Fc7c106877136772f",
    id: "0xd0fab38d17f4ae1db607e91fc7c106877136772f0002000000000000000001eb",
    name: "ECLP-VIRTUAL-WETH-dyn",
    type: "GyroE",
    gauge: "0x3D992d4172cD8CC8ACB7AC791b479ce709637061",
    tokens: [
      {
        address: "0x0b3e328455c4059EEb9e3f84b5543F74E24e7E1b",
        symbol: "VIRTUAL",
      },
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xDaa2d9be4f10622795676E59722bE1bBFa6C1fF0",
    id: "0xdaa2d9be4f10622795676e59722be1bbfa6c1ff00002000000000000000001db",
    name: "sPRF",
    type: "Weighted",
    gauge: "0xa7b9029f85FFd821b262f8DcA4EA577Bc215a2a0",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x431c248257c1d3897FeA3B99eb8e2e4De008cBDF",
        symbol: "PRF",
      },
    ],
  },
  {
    bpt: "0xE40cBcCba664C7B1a953827C062F5070B78de868",
    id: "0xe40cbccba664c7b1a953827c062f5070b78de86800020000000000000000001b",
    name: "50WETH-50GOLD",
    type: "Weighted",
    gauge: "0xe2f2AED19fa245AFf66342c2b849BE6f411fB28f",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0xbeFD5C25A59ef2C1316c5A4944931171F30Cd3E4",
        symbol: "GOLD",
      },
    ],
  },
  {
    bpt: "0xED4B8A5EAA2CE5B64FC559A1E88dB414eE46d1E3",
    id: "0xed4b8a5eaa2ce5b64fc559a1e88db414ee46d1e30002000000000000000001bf",
    name: "ECLP-GYD-USDC",
    type: "GyroE",
    gauge: "0x6A058B559149A290dF50540aF9625f0fF7e4933D",
    tokens: [
      {
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        symbol: "USDC",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0xEFEcF3A2b6adE967436F2eA3Bc1657Cd623fa847",
    id: "0xefecf3a2b6ade967436f2ea3bc1657cd623fa8470002000000000000000001e6",
    name: "ECLP-cbBTC-WETH-dyn",
    type: "GyroE",
    gauge: "0xac1Ba6eeb59C17f23Fa513344a73172CA8f39cB9",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
        symbol: "cbBTC",
      },
    ],
  },
] as const
